import { Token } from '../../data/models/base';
import { TokenService } from '../services/base';

export class BaseComponent {
    token: Token;

    constructor() { 
        this.token = TokenService.getToken();
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/common/base.component.ts